import React, { FunctionComponent } from 'react';

import { PageSectionBlok, PageSectionProps } from './PageSection';
import { Section } from './Section';

interface Blok extends PageSectionBlok {
  text: string;
  mobile: string;
  tablet: string;
  desktop: string;
}

interface TextComponentProps extends PageSectionProps {
  blok: Blok;
}

export const Text: FunctionComponent<React.PropsWithChildren<TextComponentProps>> = ({ blok }) => {
  const { mobile, tablet, desktop, text, hasPaddingBottom, hasPaddingTop, hasBackground } = blok;
  const mobileDevices = mobile && `sm:${mobile}`;
  const tabletDevices = tablet && ` md:${tablet}`;
  const desktopDevices = desktop && ` lg:${desktop}`;
  return (
    <Section hasPaddingBottom={hasPaddingBottom} hasPaddingTop={hasPaddingTop} hasBackground={hasBackground}>
      <p className={mobileDevices + tabletDevices + desktopDevices}>{text}</p>
    </Section>
  );
};
